import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function createPage(data: any, siteUid: string, oauthTokenHeader: string) {
    return fetchWrapper.post(
      `${apiUrl}/asset_management/pages/${siteUid}/`,
      data,
      oauthTokenHeader
    );
  }

function getPageContent(
  siteUid: string,
  pageUid: string,
  oauthTokenHeader: string
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/`,
    oauthTokenHeader
  );
}

function duplicatePage(
    data: any,
    siteUid: string,
    oauthTokenHeader: string,
    pageUid: string
  ) {
    return fetchWrapper.post(
      `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/?duplicate=1`,
      data,
      oauthTokenHeader
    );
  }

  export const createPageService = {
    createPage,
    getPageContent,
    duplicatePage
  }